'use client';

import { notFound } from 'next/navigation';

import { useStoreAppListByCategoryQuery } from '@query';

import { StorePageId } from '@api';

import Preloader from '@shared/common/components/Preloader';

import StoreAppCard from '@store:web/components/common/AppCard/StoreAppCard';
import PageHeader from '@store:web/components/layout/PageHeader/PageHeader';
import { useStoreChain } from '@store:web/components/providers/StoreChainProvider';

export interface StoreCategoryPageProps {
  page: string;
  category: string;
}

const StoreCategoryPage = ({ page, category }: StoreCategoryPageProps) => {
  const { chain } = useStoreChain();
  const { data, isPending: isLoading } = useStoreAppListByCategoryQuery({
    chain: chain?.name,
    page,
    block: category,
  });

  if (isLoading) {
    return <Preloader />;
  }

  if (!data) {
    notFound();
  }

  return (
    <>
      <PageHeader
        disableSeoTags
        page={page as StorePageId}
        extendBreadcrumbs={[
          {
            label: data.attributes.title,
            pathname: `/${page}/${category}`,
          },
        ]}
      />
      <main className="v2-container pt-1 flex-grow">
        <section className="store-block-card">
          <header className="mb-6">
            <h1 className="t-h4 sm:t-h3" data-qa="apps-page-title">
              {data?.attributes.title}
            </h1>
          </header>
          <div className="overflow-hidden">
            {!!data?.apps?.length && (
              <ul className="grid -mx-2 -mb-3 grid-cols-[repeat(auto-fill,_minmax(min(100%,_320px),_1fr))]">
                {data?.apps?.map((app) => {
                  return (
                    <li
                      key={app.id}
                      className="flex py-3 px-2 border-b border-neutral-600/10"
                      data-qa="app-inside-seeall"
                    >
                      <StoreAppCard className="w-full" app={app} />
                    </li>
                  );
                })}
              </ul>
            )}
            {!data?.apps?.length && <h2 className="t-h2 text-center py-10">There are no apps</h2>}
          </div>
        </section>
      </main>
    </>
  );
};

export default StoreCategoryPage;
